const normalized = (value) => String(value || '').trim().toLowerCase();

export const isAssignableCrmUser = (user = {}) => {
  if (user.isActive === false || user.active === false || ['inactive', 'disabled', 'blocked'].includes(normalized(user.status))) return false;
  if (user.isSystem === true || user.system === true || ['system', 'technical', 'service', 'test'].includes(normalized(user.accountType || user.type))) return false;

  // Compatibilité défensive pour les anciens comptes de test dépourvus de type/flag structuré.
  const identity = [user.name, user.firstName, user.lastName, user.email].map(normalized).join(' ');
  return !(/\be2e\b/.test(identity) || /\bdev admin\b/.test(identity) || /power-balance-(editor|reader|validator)/.test(identity));
};

export const getAssignableCrmUsers = (users = []) => users.filter(isAssignableCrmUser);
